module.exports = __webpack_public_path__ + "static/media/hiTech.06a8a0cf.jpg";